export default __webpack_public_path__ + "static/media/portfolio-hover-168.b21d6be4.jpg";